import axios from 'axios';
export const nav = {
  refreshSearchHistoryPickUpButton(){
    $('.m3p-histories__mailset').map((_, element) => {
      const pickUpStatus = $(element).data('pick-up') == '1';
      if(pickUpStatus === true){
        $(element).children('.pickable-up-search-condition').hide();
        $(element).children('.picked-up-search-condition, .m3p-histories__checked').css('display', 'inline-block');
        $('.m3p-searchbox__mail_btn').show();
        $('.m3p-searchbox__mail_btn_selected').removeClass('in').hide();
      }else{
        $(element).children('.pickable-up-search-condition').css('display', 'inline-block');
        $(element).children('.picked-up-search-condition, .m3p-histories__checked').hide();
      }
    });
  },
  putPickupSearchConditionData(target, callback, error){
    axios.patch($(target).attr("href")).then(callback).catch(error);
  },
  deletePickupSearchConditionData(target, callback, error){
    axios.delete($(target).attr("href")).then(callback).catch(error);
  },
  refreshPickUpDataAttr(targetId){
    $('.m3p-histories__mailset').map((_, element) => {
      const elementId = $(element).attr('id');
      const pickupStatus = elementId === targetId ? '1' : '0';
      $(element).data('pick-up', pickupStatus);
    });
    this.refreshSearchHistoryPickUpButton();
  },
  showAlertMessage(){
    alert('ネットワークの状態が不安定です。\n通信回線の良い状況で再度アクセスしてください');
  }
}
const handleClickOnPickableUpSearchCondition = element => {
  const targetId = $(element).parent('.m3p-histories__mailset').attr('id');
  nav.putPickupSearchConditionData(element, () => nav.refreshPickUpDataAttr(targetId), () => nav.showAlertMessage());
  // 新着求人設定メールのバナーの表示条件をリロード時のURLと連動させる
  location.reload();
  return false;
}
const handleClickOnPickedUpSearchCondition = element => {
  nav.deletePickupSearchConditionData(element, () => nav.refreshPickUpDataAttr(null), () => nav.showAlertMessage());
  // 新着求人設定メールのバナーの表示条件をリロード時のURLと連動させる
  location.reload();
  return false;
}

$(document).on('click', '.pickable-up-search-condition', event => handleClickOnPickableUpSearchCondition(event.currentTarget));
$(document).on('click', '.picked-up-search-condition', event => handleClickOnPickedUpSearchCondition(event.currentTarget));
$(document).ready(() => nav.refreshSearchHistoryPickUpButton());
